// constants, class definitions, and createjs library
import * as createjs from "createjs-module";
import { UserPrefType } from 'src/app/shared/constant/canvasSymTypes';

import { STATE_NORMAL, STATE_OPEN_FILE,STATE_INIT,STATE_IN_CLIPBOARD_SELECT, STATE_IN_ABC,KEY_ID_ALT_E,
  STATE_IN_GRID_FRACTION_NUM, STATE_IN_GRID_FRACTION_DEN,STATE_IN_WHITESPACE_ADD, STATE_VIEW_ONLY_FILE,
  MProbType,MLineType, MBranchType,SymbolType,SymbolLong,SymbolSimple} from 'src/assets/js/cv-classes.js';
import {DISPLAY_TYPE_GRID, DISPLAY_TYPE_LINE, DISPLAY_TYPE_TEXT,EQUALS_PREFS_COLOR,OPERATORS_PREFS_COLOR,NEG_PREFS_COLOR,
       CREATEJS_NAME_CARRY_TEXT,SIZE,START_XPOS,START_YPOS,whiteSpaceSelector,ONE_PAGE_LENGTH,
       whiteSpaceSize} from 'src/app/shared/constant/drawConstants';

// functions and variables
import {db,stage,cvControl,clearProbState, doNewProblem, draw,notifySideboardLev3Mode} from 'src/assets/js/draw.js';
import { drawProbShapes, hideGridShape, drawCursor,drawCursorAt,makeProbSelected,
          makeProbSelectedAt,clearLineSegDots,setStageBackground,
          handleStageMouse } from 'src/assets/js/cv-graphics-mouse.js';
import { pushOneNullSym,insertTopGridRow,insertProbStartColumn,trimGrid } from 'src/assets/js/cv-grid-entry.js';
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import { getSymFont,findProbEndX, findProbEndY,removeChildFromStage,tallyLineSymWidths,
         findNextPIndex,findPrevPIndex,deleteEmptyProb,
         resetTreeProbHeight, setSymColor, checkMatch,
         resetTreeXYPosAndCursor, resetMoveTreeProbHeight,checkLev3Mode,doStageUpdate} from 'src/assets/js/cv-helpers.js';



/*** 
 function startMProb is called every time a new math problem needs to be created to create the
 internal structures of the problem.  It is called by higher level routines in draw,
 after stage clicks and during open file redraws
 
 mFileProb parameter is optional and only passed during in when an opened file is being redrawn  
***/

export function startMProb(displayType,mFileProb) {  

  //console.log("start Prob", displayType, db.mathLevel);

    if (db.state == STATE_VIEW_ONLY_FILE) {
      return;
    }
  
    // first increase the index for the next math problem to create
    // then push the new math problem object onto the math problem list at db.mProb;
    let useGridWidth, useGridH;
    
    // when switching to a new problem, clean up the old one by
    // clearing event listeners and removing any problem scaling or bounding box
    if (db.curContainer != null) {
      //db.curContainer.removeAllEventListeners();
  
      if (db.curProb.scalingBox != null) {
        db.curProb.scalingBox.removeAllEventListeners();
        db.curContainer.removeChild(db.curProb.scalingBox);
        db.curProb.scalingBox = null;
      }
     
      // check if prior problem was blank, and delete if so
     
      if (db.curProb.width == 0 && db.curProb.displayType != DISPLAY_TYPE_TEXT && db.pIndex >=0) {

        removeChildFromStage(db.mProb[db.pIndex].container);
        db.mProb.splice(db.pIndex, 1);
        db.pIndex--;
        doStageUpdate();
      } else {              // FIX for line type, hide all types
        hideGridShape(db.curProb); // hide the grid of the prior problem
      }
    }
  
    // create new problem structures
    db.pIndex = db.mProb.length; // move to the end of the problem array
                                          // FIX for line type - after open
    if (db.state == STATE_OPEN_FILE) {    // use the font size and grid size saved to file on open only
      
      db.mProb.push(
        new MProbType(db.xpos, db.ypos, displayType, mFileProb.gridW,mFileProb.gridH,
          mFileProb.font,mFileProb.fontIndex));
        db.mProb[db.pIndex].probScale = mFileProb.pScale;
        //console.log("In new prob", mFileProb,db.mProb);
       
    }
    else {          // otherwise create new math problem using current sizes based on db.fontIndex

      // use a alternate more narrow grid width if there is an image file
      
      //console.log(displayType,SIZE[db.fontIndex].altWidth,SIZE[db.fontIndex].gridWidth,db.gridWidth);
      /*
      if (db.fileImage != null) {
        useGridWidth = SIZE[db.fontIndex].altWidth;
      }
      else {
        useGridWidth = SIZE[db.fontIndex].gridWidth;
      }
      */
     
     // to support font spacing setting in user prefs, don't use gridWidth for line
     // problems as this value has been adjusted for font spacing, and want original
     // size for lines, as the individual symbols need to adjust the spacing in line problems
     if (displayType == DISPLAY_TYPE_GRID || displayType == DISPLAY_TYPE_TEXT) {
      useGridWidth = db.gridWidth;
      useGridH = db.gridHeight;
     }
     else {
      useGridWidth = SIZE[db.fontIndex].gridWidth;
      useGridH = SIZE[db.fontIndex].gridHeight;
     }
     //console.log("new prob gridwidth",useGridWidth);

      db.mProb.push(
      new MProbType(db.xpos, db.ypos, displayType,useGridWidth,
        useGridH,SIZE[db.fontIndex].font, db.fontIndex));
    }
   
    db.curProb = db.mProb[db.pIndex];
    //console.log(db.curProb,db.fontIndex);
    db.curProb.lIndex++;
    if (displayType == DISPLAY_TYPE_LINE) {
      db.curProb.line.push(new MBranchType());
    }
    else {
      db.curProb.line.push(new MLineType());
    }
    db.curLine = db.curProb.line[0];
    // make a createjs container to hold this math problem, and save it's index in the math problem
    db.curContainer = new createjs.Container();
    //db.curContainer.mouseChildren = false;    // turn off separate mouse clicks for children

    //console.log("check x,y pos",db.xpos, db.ypos);
  
    db.curContainer.x = db.xpos - db.curProb.halfGW;
    db.curContainer.y = db.ypos - db.curProb.halfGH;
    db.curContainer.scaleX = db.curContainer.scaleY = db.curProb.probScale;
    db.curProb.container = db.curContainer; // may not need this, save the createjs container index in the math problem
    db.curContainer.name = "con"; // save the index of the associated math problem as the name of the container, to locate on mouse event
    
    // turn off mouseEnabled if in view only so that on Ipads the stage clicks for scroll simulation will 
    // happen even under problems
    if (db.inOpenViewOnly) {
      db.curContainer.mouseEnabled = false;
    }

    if (db.inIpad) {
      db.stageDragContainer.addChild(db.curContainer);
    }
    else {
      stage.addChild(db.curContainer); // nothing new to draw, don't need to update stage
    }
    

    // to allow support of users changing level, check if problem should be just shown view only, with no clicks allows
    if (db.state == STATE_OPEN_FILE) {
      db.curProb.matchLevel = checkMatch(db.curProb.displayType);
      //console.log("here check match", db.curProb.matchLevel);
    }

    if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
      
      // create a blank grid for this problem, adjust half a grid less to adjust for the difference between boxes and text positions
      drawProbShapes(2, 1); // start with 2x1 grid
      drawCursor(db.curContainer.x, db.curContainer.y); 
    }
    else if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      // Line problems have each line in a separate container
      // create this container and switch db.curContainer to it
      db.curLine.container = new createjs.Container();
      db.curLine.container.x =  0; 
      db.curLine.container.y = 0; 
      db.curLine.bHeightBot = db.curProb.gridH; // initialize for main line to height of line, bscale of 1
      resetTreeProbHeight();
      db.curContainer.addChild(db.curLine.container);
      db.curBranch = db.curLine;
      // CHANGE stuff to draw problem box here or adjust drawProbShapes
      drawProbShapes(.2, 1); // start with 2x1 grid
      drawCursor(db.curContainer.x, db.curContainer.y); 
      
    }
    //console.log("end new problem", db.curProb);
  }


  
  /***
   * function resizeProbGridChange is called when the user changes the font size, to resize
   * the current problem.  It does this by simply scaling that problem.  New problems will be drawn
   * at the new font size, and old problems will stay the original size based on the problems grid size
   */ 
  export function resizeProbGridChange() {

    let scale;
  
    if (db.curProb != null) {
      let oldGridW = db.curProb.gridW;
      if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
        oldGridW = db.curProb.gridW; //SIZE[db.curProb.fontIndex].gridWidth;
        scale = SIZE[db.fontIndex].gridWidth/oldGridW;
        //console.log(oldGridW, scale,SIZE[db.fontIndex].gridWidth, db.curProb.fontIndex,SIZE[db.curProb.fontIndex]);
      }
      else {
        oldGridW = db.curProb.gridW;
        scale = db.gridWidth/oldGridW;
      }
      
      // scale = db.gridWidth/SIZE[db.curProb.fontIndex].gridWidth;
      db.curProb.probScale = scale;
     
      db.curContainer.scaleX = db.curContainer.scaleY =  scale;
   
      doStageUpdate();
    }
  }  
  
// called for grid problems
export function drawOneSymText(keyID, symFont,  symLength,typeCode) {


    let color = setSymColor(keyID, typeCode); 
  
    let text = new createjs.Text(keyID, symFont, color);
    text.x = db.xpos - db.curContainer.x; 
    text.y = db.ypos - db.curContainer.y;         // adjust so symbol in center of grid

    //console.log("fraction state",db.curProb.fracState);

    // If within grid fraction, adjust position for text within this grid space
    if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM) {  
      text.y -= db.curProb.gridW*.35;
      text.maxWidth = db.curProb.gridW*.9;
    }
    else if (db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) { 
      text.y += db.curProb.gridW*.35;
      text.maxWidth = db.curProb.gridW*.9;
    }
    
    //if ((symLength === 1 ) || (typeCode == symConst.CV_UNITS_TYPE)) {
      text.textAlign = "center"; // spacing requires individual char symbols to be centered,
    //} else {    // this branch not used in grid consider removing
    //  text.textAlign = "left"; // but multi-character symbols to be left justified
    //}
    text.textBaseline = "middle";
    text.mouseEnabled = false;
    db.curContainer.addChild(text);
    doStageUpdate(); // draw symbol
  
    return text;
  }


  // called for grid problems
  /**
   * function drawOneTreeSym creates a draws a createjs text object for one symbol
   * if noDisplay is true then the stage is not redrawn, this is in the case of an insert
   * when the object needs creating but will be redrawn after other symbol coordinates are adjusted
   */
export function drawOneTreeSym(keyID,  symFont,sym, typeCode,noDisplay) {
 
  let text;
  let color = setSymColor(keyID, typeCode); 

 // console.log("here",keyID,sym.altStr);
  // adjust to the alt text, unless it's an E from a natural log E, then use original 
  // this to identify on open files keyboard e from e math sign
  if (sym.altStr && keyID != symConst.KEY_ID_E) {
    text = new createjs.Text(sym.alt, symFont, color);
  }
  else {
    text = new createjs.Text(keyID, symFont, color);
  }
  // find width of problem before this symbol, not incuding current sIndex that includes ths symbol
  let findWidth = tallyLineSymWidths(db.curBranch,db.curBranch.sIndex-1);
 
  //console.log("findWidth before", keyID, " is ", findWidth);
  
  text.x = (findWidth * db.curProb.gridW) + // not db.curBranch.bScale in tally) + 
            (db.curProb.gridW * db.curBranch.bScale * sym.symOffsetX);             
  text.y = db.curBranch.bScale * db.curProb.halfGH;

  // move line segment characters to top of grid height
  if (text.text == symConst.KEY_ID_LONG_LINE_SEGMENT) {
  
    if (!db.curLine.isBranch && (db.curLine.sym.length == 1 || db.curLine.bHeightTop == -.5*db.curProb.gridH)) {
      text.y = 0*db.curProb.gridH;  //-.3
      db.curLine.bHeightTop= -.5*db.curProb.gridH; 
      db.curLine.bHeightBot= .35*db.curProb.gridH;  //.1
      resetMoveTreeProbHeight();
      drawProbShapes();
    }
  }
  else {
    if (!db.curLine.isBranch && db.curLine.bHeightTop + db.curLine.bHeightBot == .3) {
      db.curLine.bHeightBot = db.curProb.gridH;
      resetMoveTreeProbHeight();
      drawProbShapes();
    }
  }

  //sym.width == 1 || 
  if (typeCode == symConst.CV_NUM_TYPE || typeCode == symConst.CV_OPERATOR_TYPE || typeCode == symConst.CV_EQUALS_INQ_TYPE) { // } && sym.symOffsetX == sym.width/2)  {
 
    text.textAlign = "center"; // spacing requires individual char symbols to be centered,
  } else {    // this branch not used in grid consider removing
   
    text.textAlign = "left"; // but multi-character symbols to be left justified
  }
  text.textBaseline = "middle";
  
  text.mouseEnabled = false;
  
  // don't put text into problem container, instead put it in sub-container of current line/branch
  db.curBranch.container.addChild(text);
  if (!noDisplay) {
    doStageUpdate(); // draw symbol
  }
  return text;
}

// called to draw if doing a carry after a cross-off 
export function drawCarryText(symObj, keyID, symFont, color) {
  //console.log(symObj);
  
  let numStr;
  let sendComplete = false;
  if (symObj != null) {  // prevent error conditions if grid gets mixed up
    let text=  symObj.crossOff.getChildByName(CREATEJS_NAME_CARRY_TEXT);

    // if this is the second carry text digit, then add it text of the other one
    if (text != null) {
      numStr = text.text + keyID;
      symObj.crossOff.removeChild(text);
      symObj.crossOffAddComplete = false;
      sendComplete = true;
    }
    else {
      numStr = keyID;
    }

    // make a createjs object for the carry digits, positioned in the same
    // grid position/symbol position and in the top right corner of the box
    color = db.userPrefs.cvMainColor;
    text = new createjs.Text(numStr, symFont, color);
    text.name = CREATEJS_NAME_CARRY_TEXT;
    text.x = text.y = 0;
  
    text.textAlign = "left"; 
    text.textBaseline = "hanging";
    text.mouseEnabled = false;
    symObj.crossOff.addChild(text);
    doStageUpdate(); // draw symbol
  }
  else {
    console.log("error at drawCarryText ", symObj, db.curLine, db.curProb);
  }
  if (sendComplete) {
    cvControl(symConst.CV_CNTL_COMPLETE);
  }
  else if (db.state == STATE_OPEN_FILE) {
    //db.xpos -= db.curProb.gridW;
  }

}

/*** 
function drawOneSym  just draws the current keyID symbol into the current x,y position
It is called from drawGridSym
old not used recently
*/
/*
export function drawOneSym(keyID, groupCode, typeCode) {
    if (db.state == STATE_INIT) {
      // first time any symbol is drawn, set the state to active/normal
      db.state = STATE_NORMAL; // this may need setting extra places
    }
    ///if (db.state == STATE_NORMAL) {
      // this may need to be changed later
    //  db.mathFile.addData(keyID); // temporary test way of creating save file, before data structures exist
    //}
   
    
    // figure out the right font for this symbol
    let symFont = getSymFont(keyID, typeCode);
    if (keyID === symConst.KEY_ID_MULTIPLY_2) {
      keyID = ".";
    }
    let symLength = keyID.length;
  
    // create a symbol object for this symbol in current line and math problem, and assign symbol value and type
    let newSym = new SymbolSimple(keyID, typeCode); // change this to support different symbol types
    db.curLine.sym[++db.curLine.sIndex] = newSym;
  
    // create and draw a box around this symbol
    let grid = drawOneGridBox();
    new createjs.Shape(); // make a box around the symbol
  
    // set up a createjs object to draw this symbol
    let text = drawOneSymText(keyID, symFont,  symLength,typeCode,);
    db.curLine.sym[db.curLine.sIndex].displayText = text;
    //console.log("curline ", db.curLine);
  
    // test version only code to adjust x,y position after draw
    if (db.xpos + 3 * db.curProb.gridW > stage.canvas.width) {
      // start new line, later change to > stage.canvas.width) {
      db.xpos = dConst.START_XPOS;
      db.ypos += db.curProb.gridH;
      curProbYpos = db.ypos;
    } else {
      // move x position over, just for initial test version
      if (symLength === 1) {
        // single charater, move over 1 grid width
        db.xpos += db.curProb.gridW;
      } else {
        // multi-chars length
        db.xpos += db.curProb.gridW + (db.curProb.gridW * keyID.length) / 2; // for test just adjust spacing roughly
      }
    }
  }
  
  */
// careful before using this, need to deal with effects on pindex and db structures
function deleteMProb(pIndex) {
    removeChildFromStage(db.mProb[pIndex].container);
    db.mProb.splice(pIndex, 1);
  }

// insert a line into db structure, at the lIndex position in the mProb given
// set the cursor and x,y positions based on passed sIndex
export function insertSymLine(mProb,sIndex,lIndex) {
    let newLine = new MLineType();
    mProb.line.splice(lIndex,0,newLine);
    db.curLine = newLine;
    mProb.lIndex = lIndex;
    db.curLine.sIndex = sIndex;
    drawProbShapes(Math.max(mProb.width+1,2),mProb.line.length);
    drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
  }
 
  
  export function directionArrowMove(keyID) {

    let tempSIndex = 0;
    if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
      switch (keyID) {
        case symConst.KEYBOARD_ARROWRIGHT:
          // in case there was a fraction, clear problem state and adjust sIndex to be before fraction 
          // to allow normal movement
          if (db.curProb.fracState != STATE_NORMAL) {
            db.curProb.fracState = STATE_NORMAL;
            db.curLine.sIndex--;
          }
            
          // if within problem just move x,y, indexes and cursor over
          if (db.curLine.sIndex < db.curLine.sym.length-1) {  
            db.curLine.sIndex++;
            db.xpos += db.curProb.gridW;
            //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          }
          else {
            db.xpos += db.curProb.gridW;
            db.curLine.sIndex++;
            pushOneNullSym();
            db.curProb.width  = Math.max(db.curProb.width,db.curLine.sym.length);
            drawProbShapes(db.curProb.width+1, db.curProb.line.length);
            
            //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          }
          break;
        case symConst.KEYBOARD_ARROWLEFT:
          
          if ((db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN ||
            db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM) &&
            db.curLine.sym[db.curLine.sIndex] != null &&
            db.curLine.sym[db.curLine.sIndex].str == symConst.KEY_ID_FRACTION_GRID_SIGN) {
            
            db.curProb.fracState = STATE_NORMAL;
            // adjust sIndex since it wasn't advanced yet in a partial fraction
            db.curLine.sIndex--;
          }
          else {
            // if within problem just move x,y, indexes and cursor over
            if (db.curLine.sIndex >= 0) {    
              db.curLine.sIndex--;
              db.xpos -= db.curProb.gridW;
              //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
            }
            else {
              // Move the whole problem over a column, inserting a column of null symbols
              db.xpos -= db.curProb.gridW;
              insertProbStartColumn();
              //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
            }
        }
          break;
        case symConst.KEYBOARD_ARROWUP:
          
          if ( db.curLine.sym[db.curLine.sIndex] != null &&
            db.curLine.sym[db.curLine.sIndex].str == symConst.KEY_ID_FRACTION_GRID_SIGN &&
                  db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) {
                db.curProb.fracState = STATE_IN_GRID_FRACTION_NUM;
                //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          }
          
          else {
              // if coming from numerator, need to advance sIndex
              if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM) {
                db.curLine.sIndex--;
              }
              db.curProb.fracState = STATE_NORMAL;
              tempSIndex = db.curLine.sIndex;
              if (db.curProb.lIndex > 0) {
                db.curProb.lIndex--;
                db.curLine = db.curProb.line[db.curProb.lIndex];
                db.ypos -= db.curProb.gridH;
                // adjust the new line's sIndex to be the same as the prior lines
                // except not past the end of the new line
      
              // check if the new line was shorter than the up position, if so
              // then add empty symbols to fill the line to the current position
                for (let i =  db.curLine.sym.length-1; i < tempSIndex; i++) {
                  db.curLine.sIndex = i;
                  pushOneNullSym();
                }
                db.curLine.sIndex = tempSIndex;
                //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
              }
              else {
                insertTopGridRow();
                //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
              }
            }
         
          break;
        case symConst.KEYBOARD_ARROWDOWN:
          //if within a grid fraction, then move to the lower part of fraction instead of down a row
          if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM && 
            db.curLine.sym[db.curLine.sIndex] != null &&
            db.curLine.sym[db.curLine.sIndex].str == symConst.KEY_ID_FRACTION_GRID_SIGN) {
            db.curProb.fracState = STATE_IN_GRID_FRACTION_DEN;
            //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          }
          else {
            // if coming from denominator of fraction above, need to advance sIndex
            if (db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) {
       
              db.curLine.sIndex--;
            }
            db.curProb.fracState = STATE_NORMAL;
            tempSIndex = db.curLine.sIndex;
            if (db.curProb.lIndex < db.curProb.line.length-1) {
              db.curProb.lIndex++;
              db.curLine = db.curProb.line[db.curProb.lIndex];
              db.curLine.sIndex = tempSIndex;
              for (let j = db.curLine.sym.length; j <= tempSIndex; j++) {
                db.curLine.sIndex = j;
                pushOneNullSym();
              }
              //db.curLine.sIndex = Math.min(tempSIndex,db.curLine.sym.length);
              db.ypos += db.curProb.gridH;
              //drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
            }
            else {
              tempSIndex = db.curLine.sIndex;
              db.ypos += db.curProb.gridH;
              insertSymLine(db.curProb,db.curLine.sIndex,db.curProb.lIndex+1);
              for (let j = 0; j <= tempSIndex; j++) {
                db.curLine.sIndex = j;
                pushOneNullSym();
              }
              db.curLine.sIndex = tempSIndex;
            }
          }

          break;
        default:
          break;
      }
      drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          
    }
    else if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      switch (keyID) {
        case symConst.KEYBOARD_ARROWUP:

        if (db.curProb.lIndex > 0) {
          db.curProb.lIndex--;
          db.curLine = db.curProb.line[db.curProb.lIndex];
          db.curBranch = db.curLine;
          resetTreeXYPosAndCursor();
        }
        break;
        case symConst.KEYBOARD_ARROWDOWN:

        if (db.curProb.lIndex < db.curProb.line.length-1) {
          db.curProb.lIndex++;
          db.curLine = db.curProb.line[db.curProb.lIndex];
          db.curBranch = db.curLine;
          resetTreeXYPosAndCursor();
        }
        break;
        case symConst.KEYBOARD_ARROWRIGHT:
          // only support key moves within problem in lines 
          if (db.curBranch.sIndex < db.curBranch.sym.length-1) {  
            db.curBranch.sIndex++;
            if (db.curBranch.sym[db.curBranch.sIndex].str == symConst.KEY_ID_TAB ||
                db.curBranch.sym[db.curBranch.sIndex].str == symConst.KEY_ID_TAB_EQUAL) {
                db.xpos += db.curBranch.sym[db.curBranch.sIndex].tabWidth*db.curProb.gridW/db.curBranch.bScale;
                }
            // check if the prior symbol was a branch, and if so, traverse into the branch
            // to find the correct branch and sIndex
            else {    
              let nextSym = db.curBranch.sym[db.curBranch.sIndex];
              if (nextSym != null && nextSym.groupCode == symConst.CV_BRANCHING_GRP) {
                  db.curBranch = nextSym.branch[0];
                  db.curBranch.sIndex = -1;
                }
            
            }
          }
          // if at end of branch, then go back to main line
          else {
            if (db.curBranch.isBranch) {
              let curIndex = db.curBranch.branchIndex;
             
              // if on the first branch of a multi-part symbol, go to next branch
              if (curIndex < db.curBranch.parent.sym[db.curBranch.parentIndex].branchCount-1) {
                db.curBranch = db.curBranch.parent.sym[db.curBranch.parentIndex].branch[curIndex+1]; // branchIndex is 1 greater than array index
                db.curBranch.sIndex = -1;
              }
              else  {
                // if on the last branch of branching symbol, return to parent line
                let tempIndex = db.curBranch.parentIndex;
                db.curBranch = db.curBranch.parent;
                db.curBranch.sIndex = tempIndex;
              }
            }
            // if at end of main line, then add space character marked as null type by setting type = 
            else {
              draw(symConst.KEY_ID_SPACE,symConst.CV_SIMPLE_GRP, symConst.CV_NUM_TYPE);
            }

          }
          break;
        case symConst.KEYBOARD_ARROWLEFT:
          // only support key moves  within problem for lines
          if (db.curBranch.sIndex >= 0) {    
         
            //if (db.curBranch.sym[db.curBranch.sIndex].type != symConst.BRANCHING_GRP) {
            if (db.curBranch.sym[db.curBranch.sIndex].str == symConst.KEY_ID_TAB ||
              db.curBranch.sym[db.curBranch.sIndex].str == symConst.KEY_ID_TAB_EQUAL) {
              db.xpos -= db.curBranch.sym[db.curBranch.sIndex].tabWidth*db.curProb.gridW/db.curBranch.bScale;
              db.curBranch.sIndex--;
            }
            else {
              // check if the prior symbol was a branch, and if so, traverse into the branch
              // to find the correct branch and sIndex
              let prevSym = db.curBranch.sym[db.curBranch.sIndex];
              if (prevSym != null && prevSym.groupCode == symConst.CV_BRANCHING_GRP) {
                moveToBranchLeft(db.curBranch, db.curBranch.sIndex);
              }
              else {        
               db.curBranch.sIndex--;
              }
              //db.xpos -= db.curBranch.sym[db.curBranch.sIndex].width*db.curProb.gridW*db.curBranch.bScale; 
            }
            //drawCursor(db.xpos-db.curProb.halfGW*db.curBranch.bScale, db.ypos-db.curProb.halfGH*db.curBranch.bScale,db.curBranch.bScale);

          }
          //}
          else {
            // if move arrow left past end, then move to the parent branch of this symbol
            if (db.curBranch.isBranch) {
              // check if on the second half of a 2 part branching symbol, if so go to top half, last symbol of branch
              if (db.curBranch.branchIndex == 1)  {
                db.curBranch = db.curBranch.parent.sym[db.curBranch.parentIndex].branch[0];
                db.curBranch.sIndex = db.curBranch.sym.length-1;
              }
              else {
                // otherwise move to parent branch at parent branching symbol
                let tempIndex = db.curBranch.parentIndex;
                db.curBranch = db.curBranch.parent;
                if (db.curBranch.sIndex >= 0) { 
                  db.curBranch.sIndex = tempIndex-1;
                  }
                else {
                      db.curBranch.sIndex = tempIndex;
                }
              }
                           
            }
          }
          break;
        default:
          break;
      }
      resetTreeXYPosAndCursor();
    }
  }
  /**
   * recursive routine!
   * move to the last branch position for the given branch symbol moving to the left
   */
  function moveToBranchLeft(branch,symIndex) {

      //console.log("start free", branch,symIndex);
      let branchIndex = branch.sym[symIndex].branchCount-1;
      var nextBranch = branch.sym[symIndex].branch[branchIndex];
        //console.log("in free branchs", nextBranch);
        // some branches may have been previously deleted by user, so skip those
      if (!nextBranch.isDeleted) { 

            // move sIndex to end of line of this branch
          nextBranch.sIndex = nextBranch.sym.length-1;
          db.curBranch = nextBranch;
          let nextSym = nextBranch.sym[nextBranch.sIndex];
           if (nextSym != null && nextSym.groupCode == symConst.CV_BRANCHING_GRP) {
              moveToBranchLeft(nextBranch,nextBranch.sIndex);
          }   
        
      } 
  }

  
/** 
 * function deleteProb is called when the an empty grid or last line is deleted from a problem
 */
  export function deleteProb() {
   
    db.curContainer.removeChild(db.cursor);
    db.cursor = null;
    removeChildFromStage(db.curProb.container);    // remove createjs objects for this problem
    doStageUpdate();
    db.curProb.deleted = true;
    
    db.pIndex = findNextPIndex(db.pIndex);
    let switchMode = checkLev3Mode(db.pIndex);
  
    if (db.pIndex == -1)  { // if deleted last problem put x,y back to start and return to init state
      doNewProblem(); 
      /*
      db.xpos = START_XPOS;
      db.ypos = START_YPOS;
      //make a new blank problem so that if their are view only problems there is still data
      
      db.state = STATE_INIT;
      db.curProb = null;
      db.curContainer = null;
      db.curLine = null;
      db.curBranch = null;
      */
    }
    else {  // else set up current problem to the last problem and last problems positions
        let newProb = db.mProb[db.pIndex];

        if (newProb.displayType == DISPLAY_TYPE_LINE) {
          db.curBranch = newProb.line[newProb.lIndex];
          //db.curBranch.sIndex = -1;
        }
   
        makeProbSelectedAt(db.pIndex,newProb.lIndex,newProb.line[newProb.lIndex].sIndex);
        // grid problems need cursor set.  Line problems get this during makeProbSelected
        if (db.curProb.displayType == DISPLAY_TYPE_GRID) { 
       
          drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
        //drawCursor(findProbEndX(db.curProb)+db.curProb.xpos-db.curProb.halfGW, 
        //            findProbEndY(db.curProb)+db.curProb.ypos-db.curProb.halfGH);
        }
       
    }
    if (switchMode) {
      notifySideboardLev3Mode(switchMode);
    }

}

/** 
 * function deleteProb is called when the an empty grid or last line is deleted from a problem
 * or after newt or previous command keys
 */
 export function changeToProb(keyID) {

  //db.curContainer.removeChild(db.cursor);
  //db.cursor = null;
  let newPIndex;

  if (keyID == symConst.CV_CNTL_NEXT_PROB) {
    newPIndex = findNextPIndex(db.pIndex);
  }
  else {
    newPIndex = findPrevPIndex(db.pIndex);

  }

  if (newPIndex >= 0 ) { 
    // hide cursor, in case next one is text problem
    drawCursor();

    // clear up issues relate to states
    if (db.state == STATE_IN_ABC) {
      return;
    }
    if (db.state == STATE_IN_CLIPBOARD_SELECT)  {
      db.state = STATE_NORMAL;
      if (db.selectionArea.box != null) {
        db.selectionArea.parent.removeChild(db.selectionArea.box);
        db.selectionArea = null; 
      } 
    }
    if (db.probState != STATE_NORMAL) {
      clearProbState();
    }

    if (db.curProb.width == 0) {
      deleteEmptyProb(db.curProb);
    }
    else {
      if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
        clearLineSegDots();
        trimGrid();
      }
      hideGridShape(db.curProb);
    }


    let switchMode = checkLev3Mode(newPIndex);
    
    db.pIndex = newPIndex;
    makeProbSelected(db.pIndex);
    // grid problems need cursor set.  Line problems get this during makeProbSelected
    if (db.curProb.displayType == DISPLAY_TYPE_GRID) { 
     
    drawCursor(findProbEndX(db.curProb)+db.curProb.xpos-db.curProb.halfGW, 
                 findProbEndY(db.curProb)+db.curProb.ypos-db.curProb.halfGH);
    }
   
    if (switchMode) {
      notifySideboardLev3Mode(switchMode);
    }
    
     
  }
}
